// extracted by mini-css-extract-plugin
module.exports = {"faqDev":"faqDev--Rqzec"};